import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { FC, useMemo } from 'react';
import { hashColorKey, MUI_COLORS } from '../../utils/hash-color-key';

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'color' &&
    prop !== 'size' &&
    prop !== 'rounded' &&
    prop !== 'padded',
})<{ color: string; size: number; rounded: boolean; padded: boolean }>(
  ({ theme, color, size, rounded, padded }) => ({
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: rounded ? '50%' : '2px',
    backgroundColor: color,
    flexShrink: 0,
    margin: padded ? theme.spacing(theme.spacingSizes.xs) : 0,
  }),
);

type Props = {
  color?: string;
  colorKey?: Record<string, string | number>;
  listIndex?: number;
  size?: number;
  className?: string;
  rounded?: boolean;
  padded?: boolean;
};

const ColorIndicator: FC<Props> = ({
  color,
  colorKey,
  listIndex,
  size = 8,
  className,
  rounded = false,
  padded = false,
}) => {
  const resolvedColor = useMemo(() => {
    if (color) return color;
    if (colorKey !== undefined) return hashColorKey(colorKey);
    if (listIndex !== undefined)
      return MUI_COLORS[listIndex % MUI_COLORS.length];
    return MUI_COLORS[Math.floor(Math.random() * MUI_COLORS.length)];
  }, [color, colorKey, listIndex]);

  return (
    <StyledBox
      color={resolvedColor}
      size={size}
      className={className}
      rounded={rounded}
      padded={padded}
    />
  );
};

export default ColorIndicator;
